export enum RequestAutomationType {
  AI_SCREEN = 'AiScreen',
  AI_ENRICH = 'AiEnrich',
  FOR_EVERY_NEW_PROVIDER = 'ForEveryNewProvider',
  FOR_PROVIDERS_IN_CATEGORY = 'ForProvidersInCategory',
  FOR_PROVIDERS_WITH_NEW_ASSESSMENT_LEVEL = 'ForProvidersWithNewAssessmentLevel',
  EXPECTATION = 'Expectation',
}
